module.exports = __webpack_public_path__ + "static/media/eagle2.c2c1c4f5.png";